import { createIssueHook } from '../../utils.tsx';
import { getExternalIssueProjects } from './index.tsx';

export const useExternalIssueProjects = createIssueHook(getExternalIssueProjects);
